var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('record-info',{staticClass:"mb-100",attrs:{"record":_vm.record,"status":_vm.status,"is-large":""}}),_vm._v(" "),_c('record-status-selector',{attrs:{"record":_vm.record}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }